module.exports = __webpack_public_path__ + "static/media/apresentacao-artistas.e36b226f.mp4";